type GeoMinerSupabaseClient = (typeof import("@/integrations/supabase/client"))["supabase"];

let clientPromise: Promise<GeoMinerSupabaseClient> | undefined;

/**
 * Keep the full Supabase SDK out of the synchronous public-page bundle while
 * preserving a single shared client instance once authentication or data work
 * actually begins.
 */
export function loadSupabase() {
  clientPromise ??= import("@/integrations/supabase/client").then(({ supabase }) => supabase);
  return clientPromise;
}
